// extracted by mini-css-extract-plugin
export default {"Forbidden":"eoiUa8rf","Text":"BpyMQ4Ps","Buttons":"mkplgd13","isMobile":"laHOhDl2"};